<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <!-- <div class="personal-details">
       
        <h4 class="personal-details-title">Prospect-List</h4>
        <div class="prospect-status">
          <select name="" id="" class="form-control" [(ngModel)]="prospectStatus" (change)="getProspect(prospectStatus)">
            <option [value]="status" *ngFor="let status of statusList">{{status}}</option>
          </select>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Application Form</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Mobile</th>
              <th scope="col">Status</th>
              <th scope="col">Assigned to</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let x of data | paginate : {
              itemsPerPage: tableSize,
              currentPage: page,
              totalItems: count
              };let i = index">
              <td scope="col">{{x.prospectRegistrationId}}</td>
              <td scope="col">{{x.applicationFormFor}}</td>
              <td scope="col">{{x.applicationName}}</td>
              <td scope="col">{{x.applicantEmailId}}</td>
              <td scope="col">{{x.applicantMobileNo}}</td>
              <td scope="col">{{x.latestApplicationStatus}}</td>
              <td scope="col" *ngIf="x.latestApplicationStatus == 'APPROVED' || x.latestApplicationStatus == 'VERIFIED' || x.latestApplicationStatus == 'REJECTED'"><button class="btn-disabled"disabled>assign</button></td>
              <td scope="col" *ngIf="x.latestApplicationStatus != 'APPROVED' && x.latestApplicationStatus != 'VERIFIED' && x.latestApplicationStatus != 'REJECTED'"><button  (click)="getProspectByID(x.prospectRegistrationId)" data-toggle="modal" data-target="#assignModel">assign</button></td>
              <td class="action-icons">
                <i class="bi bi-phone" (click)="showPhoneOtp(x.applicantMobileNo)"></i>
                <i class="bi bi-envelope" (click)="showEmailOtp(x.applicantEmailId)"></i>
                <i class="bi bi-eye-fill" (click)="getProspectByID(x.prospectRegistrationId)" data-toggle="modal" data-target="#exampleModalCenter"></i>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pagination-block" *ngIf="data.length != 0">
          <pagination-controls
            previousLabel="Prev"
            nextLabel="Next"
            (pageChange)="onTableDataChange($event)"
          >
          </pagination-controls>
        </div>
      </div> -->


      <div class="personal-details">

        <div class="header-block">
            <div class="header-title">
              <app-breadcrumb></app-breadcrumb>
            </div>
            <div class="add-block">
                <div class="">
                  <select name="" style="text-align: center;margin-bottom: 0;margin-right: 10px;" id="" class="form-control" [(ngModel)]="prospectStatus" (change)="getByProspectStatus(prospectStatus)">
                    <option [value]="status" *ngFor="let status of statusList">{{status}}</option>
                  </select>
                </div>
                <div class="filter-icon">
                  <i class="bi bi-funnel" title="Filter" (click)="toggleFilter()"></i>
                  <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                </div>
            </div>

        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 table-data" [ngClass]="{'col-lg-9 col-md-9 ': showFilter}">
              <table class="table table-striped" >
                <thead>
                    <tr>
                      <th style="width: 7%;">#</th>
                      <th style="width: 15%;">Application Form</th>
                      <th style="width: 15%;">Name</th>
                      <th style="width: 20%;">Email</th>
                      <th style="width: 12%;">Mobile</th>
                      <th style="width: 10%;">Created Date</th>
                      <th style="width: 11%;">Assigned to</th>
                      <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
                    </tr>
                </thead>
            </table>
            <div *ngIf="!isLoading">
                <div class="data-view" *ngFor="let x of data | paginate : {
                      itemsPerPage: recordsPerPage,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                    }  ;let i = index">

                      <p style="width: 7%;">{{x.prospectRegistrationId}}</p>
                      <p style="width: 15%;">{{x.applicationFormFor}}</p>
                      <p style="width: 15%;">{{x.applicationName}}</p>
                      <p style="width: 20%;">{{x.applicantEmailId}}</p>
                      <p style="width: 12%;">{{x.applicantMobileNo}}</p>
                      <p style="width: 10%;">{{x.createdDate | date}}</p>
                      <p style="width: 11%;text-align: center;" *ngIf="x.latestApplicationStatus == 'APPROVED' || x.latestApplicationStatus == 'VERIFIED' || x.latestApplicationStatus == 'REJECTED'"><button class="btn-disabled"disabled>assign</button></p>
                      <p style="width: 11%;text-align: center;" *ngIf="x.latestApplicationStatus != 'APPROVED' && x.latestApplicationStatus != 'VERIFIED' && x.latestApplicationStatus != 'REJECTED'"><button  (click)="getProspectByID(x.prospectRegistrationId)" data-toggle="modal" data-target="#assignModel">assign</button></p>
                      <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                        <i class="bi bi-phone" (click)="showPhoneOtp(x.applicantMobileNo)"></i>
                        <i class="bi bi-envelope" (click)="showEmailOtp(x.applicantEmailId)"></i>
                        <i *ngIf="actionControls.isView" class="bi bi-eye-fill" (click)="getProspectByID(x.prospectRegistrationId)" data-toggle="modal" data-target="#exampleModalCenter"></i>
                      </p>

                </div>
            </div>


            <div class="loader" *ngIf="isLoading">
              <div class="spinner"></div>
            </div>

            <div class="loader"  *ngIf="!isLoading && data.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>
            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="recordsPerPage" [totalRecords]="totalRecords"
                    [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
            </div>
          </div>
          <div class="col-lg-3 col-md-3" *ngIf="showFilter">
            <div class="filter-block">
              <div class="filters">
                <div class="filter-title">
                  <p>{{ 'filters.filter' | translate }}</p>
                  <div class="filter-apply-button">
                    <button (click)="resetFilter()">{{ 'filters.reset' | translate }}</button>
                    <button (click)="applyFilter()">{{ 'filters.apply' | translate }}</button>
                  </div> 
                </div>
            

                <div class="filter-section">

                  <div class="form-group">
                    <label>
                      <input type="radio" name="filter" [checked]="selectedFilter === 'phoneFilter'" (change)="onFilterSelect('phoneFilter')"/>
                      Phone
                    </label>
                    <input type="text" class="form-control" [(ngModel)]="phoneFilter" [disabled]="!phoneChecked" />
                  </div>

                  <div class="form-group">
                    <label>
                      <input type="radio" name="filter" [checked]="selectedFilter === 'emailFilter'" (change)="onFilterSelect('emailFilter')"/>
                      Email
                    </label>
                    <input type="text" class="form-control" [(ngModel)]="emailFilter" [disabled]="!emailChecked" />
                  </div>


                </div>
              </div>
            </div>
          </div>
         </div>


  
    </div>
    </div>
  </div>
</div>

<div class="modal fade" id="assignModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header assign-header">
        <p>assign to</p>
      </div>
      <div class="modal-body assign-body">
        <div class="row" [formGroup]="form">
          <div class="col-md-8 col-lg-8">
            <select name="" id="" class="form-control" formControlName="userId">
              <option [value]="user.userId" *ngFor="let user of usersWithoutCustomers">{{user.userName}}</option>
            </select>
          </div>

          <div class="col-md-4 col-lg-4">
            <button class="btn btn-primary" (click)="prospectAssignToUser()">submit</button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" id="closeModalButton3" class="btn btn-secondary" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="prospect-block" *ngFor="let data of prospectdata">
        <div class="prospect-content">
          <div class="application-details">
            <p class="application-title">Application Details:</p>
            <div class="row application-form-details">
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Application For</label>
                <p *ngIf="data.applicationFormFor != ''">{{data.applicationFormFor}}</p>
                <p *ngIf="data.applicationFormFor == ''">--</p>

              </div>
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Number of Cable Connection</label>
                <p *ngIf="data.noOfInternetConnection != ''">{{data.noOfCableConnection}}</p>
                <p *ngIf="data.noOfCableConnection == ''">--</p>

              </div>
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Number of Internet Connection</label>
                <p *ngIf="data.noOfInternetConnection != ''">{{data.noOfInternetConnection}}</p>
                <p *ngIf="data.noOfInternetConnection == ''">--</p>

              </div>
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Terms of Payment</label>
                <p *ngIf="data.termsOfPayment != ''">{{data.termsOfPayment}}</p>
                <p *ngIf="data.termsOfPayment == ''">--</p>

              </div>
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Booked By</label>
                <p *ngIf="data.bookedBy != ''">{{data.bookedBy}}</p>
                <p *ngIf="data.bookedBy == ''">--</p>
                

              </div>
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Agent Name</label>
                <p *ngIf="data.agentName != ''">{{data.agentName}}</p>
                <p *ngIf="data.agentName == ''">--</p>
              </div>
            </div>
          </div>

          <div class="applicant-details">
            <p class="applicant-title">Personal Details:</p>
            <div class="row applicant-form-details">
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Name</label>
                <p>{{data.applicationName}}</p>
              </div>
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Father/Husband Name</label>
                <p>{{data.fatherHusbandName}}</p>
              </div>
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Email</label>
                <p *ngIf="data.applicantEmailId != ''">{{data.applicantEmailId}}</p>
                <p *ngIf="data.applicantEmailId == ''">--</p>
              </div>
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Mobile No</label>
                <p>{{data.applicantMobileNo}}</p>
              </div>
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Address</label>
                <p>{{data.installationAddress}}</p>
              </div>
            </div>
          </div>


          <div class="identity-proof-details">
            <p class="identity-proof-title">Identity Proofs:</p>
            <div class="row identity-proof-form-details">
              <div class="col-md-12 col-lg-12 identity-proof-form">
                <label for="">Proof Type</label>
                <p>{{data.identityProofType}}</p>
                <div class="proof-images">
                  <div class="image">
                    <img src="{{data.identityProofAttachmentURL}}" alt="">
                  </div>
                  <div class="image">
                    <img src="{{data.photoAttachmentURL}}" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div class="feasibility-details">
            <p class="feasibility-title">Feasibility Details:</p>
            <div class="row feasibility-form-details">
              <div class="col-md-12 col-lg-12 feasibility-form">
                <label for="">Feasibility Report</label>
                <p>{{data.description}}</p>
              </div>

              <div class="feasibility-images" >
                <div class="image col-md-3 col-lg-3" *ngFor="let image of data.feasibilityImageList">
                  <img src="{{image}}" alt="">
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" (click)="printProspect()"><i class="bi bi-printer"></i> Print</button>
          <button type="button" class="btn btn-primary" (click)="downloadProspect()"><i class="bi bi-download"></i> Download</button>
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast></p-toast>
